export const environment = {
  BASE_URL: "https://sportscomplexbilimora.com/API/AdminAPI",
  BASE_URL2: "https://sportscomplexbilimora.com/API/AdminAPI",
  
}
